<template>
  <div class="advertisement">
    <div class="advertisement-header">
      <div class="advertisement-header-text">
        <h3>企业咨询审核</h3>

      </div>
    </div>
    <records type="2"></records>
  </div>
</template>

<script>
import records from "../components/records"
export default {
  components:{
    records
  },
  data(){
    return{

    }
  },
  methods:{

  }
}
</script>

<style scoped lang="less">
.fontdemo(@size,@family,@weight,@color){
  font-size:@size;
  font-family:@family;
  font-weight:@weight;
  color:@color
}
.advertisement{
  width: 100%;
  &-header{
    width: 100%;
    height: 600px;
    background: url("../assets/background2.png") no-repeat;
    background-size: cover;
    display: flex;
    justify-content: flex-end;
    &-text{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-right: 190px;
      align-items: flex-end;
      h3{
        .fontdemo(47px, 'PingFangSC,PingFang SC', 600, #000000);
        margin: 0;
      }
      p{
        .fontdemo(30px, 'PingFangSC,PingFang SC', 400, #000000);
        margin: 22px 0 49px;
        max-width: 700px;
        line-height: 50px;
        text-align: right;
      }
      div{
        width: 154px;
        height: 52px;
        background: #4787F0;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        .fontdemo(18px, 'PingFangSC,PingFang SC', 500, #FFFFFF);
        cursor: pointer;
      }
    }
  }
}
</style>